import { Dispatch } from "redux";

import { MemberActionTypes } from "./types";
import baseApi from "../apis/baseApi";

export interface MemberState {
  loading: boolean;
  fetched: boolean;
  member?: Member;
  error?: string;
}

export interface Member {
  birthday: string;
  emergency_contact_phone: string;
  extra_fields: string[];
  facebook_url: string;
  full_name: string;
  id_number: string;
  img: string;
  injuries: string;
  instagram_username: string;
  last_name: string;
  phone: string;
  preferred_branch: string;
  shoe_size: string;

  [property: string]: any;
}

export interface MemberAction {
  type: MemberActionTypes,
  payload: any
}

export const fetchSelfMember = () => {
  return async (dispatch: Dispatch) => {
    dispatch<MemberAction>({ type: MemberActionTypes.MEMBER_LOADING, payload: null });
    baseApi.get<Member>("/members/current/").then((resp) => {
      dispatch({ type: MemberActionTypes.MEMBER_READY, payload: resp.data });
    }).catch((err) => {
    });
  };
};
export const setMember = (member: Member) => {
  return (dispatch: Dispatch) => {
    dispatch<MemberAction>({
      type: MemberActionTypes.MEMBER_READY,
      payload: member
    });
  };
};
